import React from 'react';
import type { Player } from '../../types/bountifulSea';

// ═══════════════════════════════════════════════════════════════
// PLAYER HUD COMPONENT
// ═══════════════════════════════════════════════════════════════

interface PlayerHUDProps {
  player: Player;
  isActive?: boolean;
  showVoyageInfo?: boolean;
}

export const PlayerHUD: React.FC<PlayerHUDProps> = ({
  player,
  isActive = false,
  showVoyageInfo = false,
}) => {
  const activeClass = isActive ? 'bs-player-hud-active' : '';
  const eliminatedClass = player.isEliminated ? 'bs-player-hud-eliminated' : '';

  return (
    <div className={`bs-player-hud ${activeClass} ${eliminatedClass}`}>
      <div
        className="bs-player-avatar"
        style={{ backgroundColor: player.color }}
      >
        {player.isAI ? '🤖' : '👤'}
      </div>

      <div className="bs-player-info">
        <div className="bs-player-name" style={{ color: player.color }}>
          {player.name}
          {player.isEliminated && ' (Shipwrecked)'}
        </div>

        <div className="bs-player-stats">
          <span className="bs-stat">
            <span className="bs-stat-icon">💰</span>
            <span>{player.stash}</span>
          </span>
          <span className="bs-stat">
            <span className="bs-stat-icon">🎲</span>
            <span>{player.scoundrelDice}</span>
          </span>
          {showVoyageInfo && player.currentVoyage && (
            <span className="bs-stat">
              <span className="bs-stat-icon">🚢</span>
              <span>{player.currentVoyage.haul}</span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

// Mini player display for lists
interface PlayerMiniProps {
  player: Player;
  showStats?: boolean;
}

export const PlayerMini: React.FC<PlayerMiniProps> = ({
  player,
  showStats = true,
}) => {
  return (
    <div className="bs-player-mini">
      <div
        className="bs-player-mini-dot"
        style={{ backgroundColor: player.color }}
      />
      <span className="bs-player-mini-name">{player.name}</span>
      {showStats && (
        <span className="bs-player-mini-stats">
          💰{player.stash} 🎲{player.scoundrelDice}
        </span>
      )}
    </div>
  );
};

export default PlayerHUD;
